import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M6 3v12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 6a9 9 0 0 0-9 9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 15v6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 18h-6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "GitBranchPlus";
const GitBranchPlus = memo(themed(Icon));
export {
  GitBranchPlus
};
//# sourceMappingURL=git-branch-plus.js.map
